import payments from "./modules/payments";

export const strict = false

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import config from '@/config/app'

// Modules
import auth from "./modules/auth";
import errors from "./modules/errors";
import profile from "./modules/profile";
import subscribe from "./modules/subscribe";
import products from "./modules/products";
import categories from "./modules/categories";
import contact from "./modules/contact";
import purchase from "./modules/purchase";
import service_enquiry from "./modules/service_enquiry";
import orders from "./modules/orders";
import cart from "./modules/cart";
import checkout from "./modules/checkout";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
    modules: {
        auth,
        errors,
        profile,
        products,
        subscribe,
        categories,
        contact,
        service_enquiry,
        purchase,
        payments,
        orders,
        cart,
        checkout
    },
    strict: debug,
    plugins: [createPersistedState({
        key: config.APP_VERSION
    })]
});

export default store
